import { render, staticRenderFns } from "./TodoTemplates.vue?vue&type=template&id=5204ab18&"
import script from "./TodoTemplates.vue?vue&type=script&lang=js&"
export * from "./TodoTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports